// expects ({width:width, height:height}, {left, top, width:width, height:height});
// returns {top:top, left:left}
export default function centerRectWithinBounds(rect, bounds){
  return {
    left: (bounds.left || 0) + bounds.width / 2 - rect.width / 2,
    top: (bounds.top || 0) + bounds.height / 2 - rect.height / 2
  };
}



// WEBPACK FOOTER //
// ./src/lib/centerRectWithinBounds.js